import React, { useState } from 'react';
import styled from 'styled-components';

import { Collapse, Row } from 'react-bootstrap';
import Txt from '../atoms/Txt';
import ImgFit from '../atoms/ImgFit';
import Col from '../atoms/FlexColumn';
import useUserPhoto from '../../hooks/useUserPhoto';
import { fireStore } from '../../database/utils/firebase';

const PlanoStatus = styled.div`
  background: ${({ deleted }) => (!deleted ? 'dd7777' : '#77dd77')};
  border-radius: 6px;
  width: 30%;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
`;
const TypePlan = styled.div`
  background: #3065ac;
  color: white;
  border-radius: 6px;
  width: 30%;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
`;

const Body = styled.div`
  display: flex;
  border: 1px solid #7e7d7a;
  border-radius: 15px;
  margin-top: 1%;
  padding: 1%;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: none;
  }

  ul {
    list-style: none;
  }

  i {
    margin: 8px 8px;
    font-size: 40px;

    @media (max-width: 768px) {
      font-size: 23px;
      margin: 1px 6px;
    }
  }

  a:hover {
    text-decoration: none;
  }

  #input[type='file'] {
    display: none;
  }
`;

const PhotoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 4px 0 8px 0;

  img {
    width: 80px;
    height: 80px;
    @media (max-width: 768px) {
      width: 120px;
      height: 120px;
    }
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ content }) => content};
  width: ${({ width }) => width || '100%'};
  font-weight: ${({ weight }) => (weight ? 'bold' : '')};

  div {
    margin-right: 8px;
  }
`;

const StyledText = styled.div`
  display: flex;
  justify-content: ${({ direction }) => (direction ? 'center' : 'flex-start')};
  align-items: center;
  width: 100%;
  font-weight: ${({ bold }) => (bold ? 'normal' : 'bold')};
  div {
    margin-right: 10px;
  }
`;

function ChargeAdmin({ charge }) {
  const { chargeId, chargeUrl, items, id } = charge;
  const { status, seller, client, product } = items[0];
  const [open, setOpen] = useState(false);

  const toggleProduct = () => {
    // if (deleted) {
    //   fireStore
    //     .collection('produtos')
    //     .doc(id)
    //     .update({ deleted: false })
    //     .finally(() => window.location.reload());
    // } else {
    //   fireStore
    //     .collection('produtos')
    //     .doc(id)
    //     .update({ deleted: true })
    //     .finally(() => window.location.reload());
    // }
    window.location.reload();
  };

  return (
    <>
      <Body
        type="button"
        aria-controls="example-collapse-text"
        aria-expanded={open}
        onClick={() => setOpen(!open)}>
        <StyledContainer>
          <StyledDiv>
            <StyledDiv width="45%" weight>
              <div>ID:</div>
              <Txt>{id}</Txt>
            </StyledDiv>

            <StyledDiv weight>
              <div>Cobrança:</div>
              <Txt>{chargeId}</Txt>
            </StyledDiv>
            <StyledDiv content="space-around">
              <PlanoStatus deleted={status}>{status}</PlanoStatus>
              {status === 'open' && <button onClick={toggleProduct}>Encerrar cobrança</button>}
            </StyledDiv>
          </StyledDiv>

          <Collapse in={open}>
            <StyledContainer id="example-collapse-text">
              <Col>
                {/* <Col>
                  <Txt bold size={22}>
                    {userData?.name}
                  </Txt>
                </Col>
                <PhotoWrapper>
                  <ImgFit id="signup_photo_img" src={img} />
                </PhotoWrapper>

                <Txt bold size={12}>
                  KAKARECANDO DESDE{' '}
                  {userData ? new Date(userData.joinDate).toLocaleDateString('pt-br') : null}
                </Txt>

                <StyledText direction>
                  <Txt href="/usuario/vitrine" color="blue" opacity>
                    Produtos
                  </Txt>
                  <Txt href="/usuario/vendas/concluidas" color="red" opacity>
                    Vendas
                  </Txt>
                </StyledText> */}

                <Row style={{ justifyContent: 'flex-start', width: '100%' }}>
                  <div>
                    <StyledText>
                      <div>Url da cobrança: </div>
                      <button onClick={() => window.open(chargeUrl)}>
                        <Txt>aqui!</Txt>
                      </button>
                    </StyledText>

                    <StyledDiv>
                      <StyledDiv weight>
                        <div>Vendedor:</div>
                        <Txt>{seller.id}</Txt>
                      </StyledDiv>

                      <StyledDiv weight>{seller.data.name}</StyledDiv>
                    </StyledDiv>
                    <StyledDiv>
                      <StyledDiv weight>
                        <div>Comprador:</div>
                        <Txt>{client.id}</Txt>
                      </StyledDiv>

                      <StyledDiv weight>{client.data.name}</StyledDiv>
                    </StyledDiv>
                    <StyledText>
                      <div>Produtos:</div>
                      <Txt>{product.data.name}</Txt>
                    </StyledText>
                  </div>
                </Row>
                <Row style={{ justifyContent: 'flex-start', width: '100%' }}>
                  {product.data.pictures.map((item) => (
                    <PhotoWrapper>
                      <img src={item} alt="Foto do produto" />
                    </PhotoWrapper>
                  ))}
                </Row>
              </Col>
            </StyledContainer>
          </Collapse>
        </StyledContainer>
      </Body>
    </>
  );
}

export default ChargeAdmin;
